<template>
  <el-dialog :visible.sync="visible"
             :title="$t('login.createCompany')"
             :close-on-click-modal="false"
             width="30%">
    <el-form label-position="top"
             :model="dataForm"
             :rules="dataRule"
             ref="dataForm"
             @keyup.enter.native="dataFormSubmitHandle()"
             label-width="120px">
      <el-form-item prop="companyName"
                    :label="$t('login.companyFullName')">
        <el-input v-model="dataForm.companyName"
                  :placeholder="$t('message.enter')"
                  :maxlength="20"></el-input>
      </el-form-item>
      <el-form-item prop="socialCreditCode"
                    :label="$t('login.socialCreditCode')">
        <el-input v-model="dataForm.socialCreditCode"
                  :maxlength="18"
                  @input="inputSocialCode"
                  oninput="value=value.replace(/[^A-Za-z0-9]/g,'')"
                  :placeholder="$t('message.enter')"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer"
          class="dialog-footer">
      <el-button type="primary"
                 @click="dataFormSubmitHandle()">{{$t('confirm')}}</el-button>
    </span>
  </el-dialog>
</template>
<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        companyName: '',
        socialCreditCode: ''
      }
    }
  },
  props: {
    jumpRoute: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    dataRule () {
      var validateSocialCreditCode = (rule, value, callback) => {
        if (value && !(value.length === 15 || value.length === 18)) {
          return callback(new Error('长度在 15 或 18 个大小写字母或者数字'))
        } else {
          callback()
        }
      }
      return {
        companyName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        socialCreditCode: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' },
          { validator: validateSocialCreditCode, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
      })
    },
    inputSocialCode () {
      if (this.dataForm.companyName && this.dataForm.socialCreditCode && (this.dataForm.socialCreditCode.length === 15 || this.dataForm.socialCreditCode.length === 18)) {
        this.$http.get('/front/cross/cust-company/check', {
          params: {
            companyName: this.dataForm.companyName,
            socialCreditCode: this.dataForm.socialCreditCode
          }
        }).then(({ data: res }) => {
          if (res.data !== null) {
            this.$confirm(this.$t('register.message1'), this.$t('prompt.title'), {
              confirmButtonText: this.$t('login.applyJoin'),
              cancelButtonText: this.$t('cancel'),
              type: 'warning'
            }).then(() => {
              this.goCompany(res.data.companyId)
            }).catch(() => { })
          }
        }).catch(() => { })
      }
    },
    goCompany (companyId) {
      this.$http.post('/front/consumer/usercenter/apply-to-join', {
        companyId: companyId,
        registClient: 'PC'
      }).then(({ data: res }) => {
        if (res.code === 0) {
          this.$message({
            message: this.$t('message.applySuccess'),
            type: 'success'
          })
          this.visible = false
          if (this.jumpRoute) {
            this.$router.replace({ name: 'basicInfo' })
          }
          setTimeout(() => {
            window.location.reload()
          }, 1000)
        }
      }).catch(() => { })
    },
    saveAll () {
      this.$http.post(`/front/user/sys/custCompany/saveCompanyAccountAPP`, this.dataForm)
        .then(({ data: res }) => {
          if (res.code !== 0) {
            return false
          }
          this.bus.$emit('refushUserInfo')
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              if (this.jumpRoute) {
                this.$router.replace({ name: 'basicInfo' })
              }
              setTimeout(() => {
                window.location.reload()
              }, 1000)
            }
          })
        }).catch(() => { })
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http.get('/front/cross/cust-company/check', {
          params: {
            companyName: this.dataForm.companyName,
            socialCreditCode: this.dataForm.socialCreditCode
          }
        }).then(({ data: res }) => {
          if (res.data !== null) {
            this.$confirm(this.$t('register.message1'), this.$t('prompt.title'), {
              confirmButtonText: this.$t('login.applyJoin'),
              cancelButtonText: this.$t('cancel'),
              type: 'warning'
            }).then(() => {
              this.goCompany(res.data.companyId)
            }).catch(() => { })
          } else {
            this.saveAll()
          }
        }).catch(() => { })
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
<style lang='scss' scoped>
</style>
